import { TextArea } from "grommet";
import { useState } from "react";
import { updateStateHandler } from "../Utils/Utils";

const Notes = (props) => {
    const [localValue, setLocalValue] = useState(props.initValue ? props.initValue : "");

    return (
        <TextArea
            tip="Notes"
            alignSelf="strech"
            placeholder="Type notes here..."
            // defaultValue={props.initValue}
            value={localValue}
            disabled={props.disable}
            onChange={(event) => setLocalValue(event.target.value)} // Handle visual update
            onBlur={(event) => {
                if (event.target.value.trim() !== props.initValue) {
                    updateStateHandler(props.stateHandler, props.fieldName, event.target.value.trim());
                }
            }}            
            size="medium"
            fill
        />
    );
};
export default Notes;
